import '@modeling/git-file-viewer/dist/git-file-viewer.css';

let ready: Promise<void> | null = null;

/** 首次进入 Git 相关页面前加载 git-file-viewer 样式（避免打进首屏 main 包） */
export function ensureGitFileViewerReady(): Promise<void> {
  if (!ready) {
    ready = Promise.resolve();
  }
  return ready;
}
